/* eslint-disable */

import {
    CoodeSdk,
    CoodeSdkOptions,
    Environments,
    LogLevel,
} from "@coode/fe-sdk";

export const APP_SCOPE = `api://${process.env.VUE_APP_CLIENT_ID}/coode`;

export const coodeSdkConfig: CoodeSdkOptions = {
    environment: process.env.VUE_APP_ENVIRONMENT as Environments,
    auth: {
        msal: {
            auth: {
                clientId: process.env.VUE_APP_CLIENT_ID as string,
                authority: process.env.VUE_APP_AUTHORITY_URL,
                redirectUri: window.location.origin,
                postLogoutRedirectUri: `${window.location.origin}/authorization/logged-out.html`,
            },
            cache: {
                cacheLocation: "sessionStorage",
            },
            system: {
                loggerOptions: {
                    logLevel: LogLevel.Verbose,
                },
            },
        },
    },
    insights: {
        appInsightsConnectionString:
            process.env.VUE_APP_APP_INSIGHTS_CONNECTION_STRING,
    },
    phraseProjectId: process.env.VUE_APP_PHRASE_PROJECT_ID,
    phraseProjectDefaultLanguage: 'en-GB',
};

export const sdk = new CoodeSdk(coodeSdkConfig);
